<template>
  <b-form-group class="form-group-feedback-item">
    <label>
      <slot name="label"></slot>
    </label>
    <b-form-radio-group
      class="feedback-options"
      v-model="rating_"
    >
      <div @click="onSelect(n)" v-for="n in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" v-bind:key="n" class="option" :class="{'selected' : (rating_ === n)}">
        <div class="label">{{n}}</div>
        <div class="radio"></div>
      </div>
    </b-form-radio-group>
    <div class="ranges">
      <div class="low"><slot name="labelLowBoundary"></slot></div>
      <div class="high"><slot name="labelHighBoundary"></slot></div>
    </div>
  </b-form-group>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'feedbackInput',
  data () {
    return {}
  },
  mounted () {
    this.rating_ = null
  },
  components: {
    BFormGroup
  },
  methods: {
    onSelect (n) {
      if (this.rating_ === n) {
        this.rating_ = null
      } else {
        this.rating_ = n
      }
    }
  },
  mixins: [
    syncProperty('rating', 'rating_')
  ]
}
</script>
